enum type {
  ACTIVE = "ACTIVE",
  COMPLETE = "COMPLETE",
}

export default type;
